import React from 'react';

import fromAnyToTrimmed from 'utils/converters/any/fromAnyToTrimmed.util';

const HeaderWrapper = ({ children, tag }) => (
  <div data-bem="HeaderWrapper" data-tag={fromAnyToTrimmed(tag)} className="bw-header-wrapper">
    {children}
  </div>
);

export default HeaderWrapper;
